import { useState, useEffect, useRef, ReactNode } from "react";

interface LazyLoadSectionProps {
  children: ReactNode;
  rootMargin?: string;
  className?: string;
}

const LazyLoadSection = ({ children, rootMargin = "200px", className }: LazyLoadSectionProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div ref={ref} className={className}>
      {isVisible ? children : <div className="min-h-[200px]" />}
    </div>
  );
};

export default LazyLoadSection;
